import ModelsCarouselMobile from '../../../../components/models-carousel/models-carousel.mobile';
import modelsCarousel from './models-carousel';

export default modelsCarousel(ModelsCarouselMobile);
